import Logo from "../static/LogoGT.svg";
import Phone from "../static/Phone.svg";
import RT from "../static/Rutube.svg";
import Vk from "../static/VK.svg";
import TG from "../static/Telegram.svg";
import { Link } from "react-router-dom";
import "./app-footer.css";
import { Row, Col, Typography, Space } from "antd";
import SiteMenu from "../site-menu";
import { CONTACT_DEFAULTS } from "../../constants";
import { useMediaQuery } from "../../hooks/useMediaQuery";

function AppFooter() {
  const isMobileXl = useMediaQuery("xl");
  return (
    <>
      {isMobileXl ? (
        <div className="footer">
          <Row justify="center" className="footer__inner">
            <Row className="footer__phone-row">
              <Col
                span={24}
                style={{
                  display: "flex",
                  justifyContent: "end",
                  minWidth: "220px",
                }}
                className={"footer__phone"}
              >
                <Space>
                  <img
                    src={Phone}
                    alt="Телефон"
                    className="footer__phone-icon"
                    loading="lazy"
                  />
                  <Typography className="footer-call-now">
                    <a href={`tel:${CONTACT_DEFAULTS.MAIN_PHONE}`}>
                      {CONTACT_DEFAULTS.MAIN_PHONE}
                    </a>
                  </Typography>
                </Space>
              </Col>
            </Row>
            <Row className="footer__menu-row">
              <Col
                span={24}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <SiteMenu
                  isFooter={true}
                  className="footer-menu"
                />
              </Col>
            </Row>
            <Row className="footer__policy-row">
              <Col className="policy" span={24} style={{ display: "flex" }}>
                <Typography>
                  <Link to="personal_information">
                    Политика конфеденциальности
                  </Link>
                </Typography>
              </Col>
            </Row>
            <Row className="footer_logo_socsety footer__bottom">
              <Col
                span={8}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyItems: "center",
                }}
              >
                <Link to="/" className="footer__logo-link">
                  <img
                    src={Logo}
                    alt="Логотип General Trucks"
                    className="footer__logo"
                    loading="lazy"
                  />
                </Link>
              </Col>
              <Col span={6}></Col>
              <Col
                span={10}
                className="footer__social"
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <Space>
                  <Link to={CONTACT_DEFAULTS.RT} target="_blank">
                    <img
                      src={RT}
                      alt="RuTube"
                      className="icon"
                      loading="lazy"
                    />
                  </Link>
                  <Link to={CONTACT_DEFAULTS.VK} target="_blank">
                    <img src={Vk} alt="VK" className="icon" loading="lazy" />
                  </Link>
                  <Link to={CONTACT_DEFAULTS.TG} target="_blank">
                    <img
                      src={TG}
                      alt="Telegram"
                      className="icon"
                      loading="lazy"
                    />
                  </Link>
                </Space>
              </Col>
            </Row>
          </Row>
        </div>
      ) : (
        <div className="footer">
          <Row justify="center" className="footer__inner">
            <Col
              span={4}
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyItems: "center",
              }}
            >
              <Link to="/" className="footer__logo-link">
                <img
                  src={Logo}
                  alt="Логотип General Trucks"
                  className="footer__logo"
                  loading="lazy"
                />
              </Link>
            </Col>
            <Col span={1}></Col>
            <Col
              span={13}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Row className="footer__menu-row">
                <Col
                  span={24}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <SiteMenu
                    mode="horizontal"
                    className="app-menu"
                  />
                </Col>
              </Row>
              <Row className="footer_logo_socsety">
                <Col
                  span={24}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Typography className="policy">
                    <Link to="personal_information">
                      Политика конфеденциальности
                    </Link>
                  </Typography>
                </Col>
              </Row>
            </Col>
            <Col span={1}></Col>
            <Col
              span={5}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Row>
                <Col
                  span={24}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    minWidth: "220px",
                  }}
                  className={"footer__phone"}
                >
                  <Space>
                    <img
                      src={Phone}
                      alt="Телефон"
                      className="footer__phone-icon"
                      loading="lazy"
                    />
                    <Typography className="footer-call-now">
                      <a href={`tel:${CONTACT_DEFAULTS.MAIN_PHONE}`}>
                        {CONTACT_DEFAULTS.MAIN_PHONE}
                      </a>
                    </Typography>
                  </Space>
                </Col>
              </Row>
              <Row>
                <Col
                  span={24}
                  className="footer__social"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <Space>
                    <Link to={CONTACT_DEFAULTS.RT} target="_blank">
                      <img
                        src={RT}
                        alt="RuTube"
                        className="icon"
                        loading="lazy"
                      />
                    </Link>
                    <Link to={CONTACT_DEFAULTS.VK} target="_blank">
                      <img src={Vk} alt="VK" className="icon" loading="lazy" />
                    </Link>
                    <Link to={CONTACT_DEFAULTS.TG} target="_blank">
                      <img
                        src={TG}
                        alt="Telegram"
                        className="icon"
                        loading="lazy"
                      />
                    </Link>
                  </Space>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}

export default AppFooter;
